import { useFormStore } from "@/features/blueprint/stores/useFormStore";

export function useBlueprintNavigation(formStore = useFormStore()) {
    function navigateToSection(index: number): void {
        formStore.currentSectionIndex = index;
        formStore.saveToLocalStorage();
    }

    return {
        navigateToSection,
    };
}
